import type { Meta } from '../lib/api';

/** Opciones de agente: primero los del grupo elegido (ITIL: el grupo resuelve, la persona ejecuta). */
export function AgentOptions({ meta, groupId }: { meta: Meta | undefined; groupId: string | null | undefined }) {
  const agents = meta?.agents ?? [];
  const group = groupId ? meta?.groups.find(g => g.id === groupId) : null;
  if (!group) return <>{agents.map(a => <option key={a.uid} value={a.uid}>{a.name}</option>)}</>;
  const inGroup = agents.filter(a => a.groupIds.includes(group.id));
  const others = agents.filter(a => !a.groupIds.includes(group.id));
  return (
    <>
      {inGroup.length > 0 && (
        <optgroup label={group.name}>{inGroup.map(a => <option key={a.uid} value={a.uid}>{a.name}</option>)}</optgroup>
      )}
      <optgroup label={inGroup.length > 0 ? 'Otros agentes' : 'Agentes'}>
        {others.map(a => <option key={a.uid} value={a.uid}>{a.name}</option>)}
      </optgroup>
    </>
  );
}
